
import {useNavigate} from "react-router-dom"
export default function MovieCard({movie}){
    const navigate = useNavigate()
    
const toDetail= (id,slug)=>{
    navigate(`/${id}/${slug}`)
}
    return(
        <div className="flex flex-col md:flex-row md:max-w-xl rounded-lg bg-gray-700 shadow-lg transition ease-in-out delay-150 hovertranslate-y-1 hover:scale-110 hover:bg-blue-800 duration-300">
          <img className=" w-full h-96 md:h-auto object-cover md:w-48 rounded-t-lg md:rounded-none md:rounded-l-lg" src={movie.imgUrl} alt="" />
          <div className="p-6 flex flex-col justify-start">
            <h5 className="text-gray-900 text-xl font-medium mb-2">{movie.title}</h5>
            <p className="text-black text-base mb-4">
            {movie.synopsis}
            </p>
            <p className="text-gray-500 text-xs ">Rating: {movie.rating}</p>
            <button className="bg-blue-500 w-24 h-8 rounded-lg mt-5" onClick={()=>toDetail(movie.id,movie.slug)}>Detail</button>
          </div>
        </div>
    )
}